(function () {
  'use strict';

  if (window.mdvCollectionRailLifecycle) return;
  window.mdvCollectionRailLifecycle = true;
  var cleanup = new WeakMap();

  function initialiseRail(shell) {
    if (shell.dataset.mdvRailInitialised === 'true') return;

    var rail = shell.querySelector('[data-mdv-collection-rail-list]');
    var previous = shell.querySelector('[data-mdv-rail-previous]');
    var next = shell.querySelector('[data-mdv-rail-next]');
    var items = rail ? rail.querySelectorAll('.mdv-collection-rail__item') : [];

    if (!rail || !previous || !next || items.length === 0) return;
    shell.dataset.mdvRailInitialised = 'true';

    var frame = null;
    var disposed = false;

    function scrollState() {
      var sign = window.getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
      var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var position = Math.max(0, Math.min(maximum, sign * rail.scrollLeft));
      return { sign: sign, maximum: maximum, position: position };
    }

    function update() {
      frame = null;
      if (disposed) return;

      var state = scrollState();
      previous.hidden = previous.disabled = state.position <= 1;
      next.hidden = next.disabled = state.maximum - state.position <= 1;
    }

    function requestUpdate() {
      if (disposed || frame !== null) return;
      frame = window.requestAnimationFrame(update);
    }

    function move(direction) {
      var state = scrollState();
      var target = Math.max(0, Math.min(state.maximum,
        state.position + direction * rail.clientWidth * 0.7));
      rail.scrollTo({
        left: state.sign * target,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function revealFocus(event) {
      var link = event.target.closest('.mdv-collection-rail__link');
      if (!link || !link.matches(':focus-visible')) return;
      var bounds = rail.getBoundingClientRect();
      var style = window.getComputedStyle(rail);
      var left = bounds.left + parseFloat(style.paddingLeft || 0);
      var right = bounds.right - parseFloat(style.paddingRight || 0);
      [previous, next].forEach(function (button) {
        var rect = button.getBoundingClientRect();
        if (button.hidden || rect.width === 0) return;
        if (rect.left <= bounds.left) left = Math.max(left, rect.right + 16);
        if (rect.right >= bounds.right) right = Math.min(right, rect.left - 16);
      });
      var rect = link.getBoundingClientRect();
      var delta = rect.left < left ? rect.left - left : Math.max(0, rect.right - right);
      if (!delta) return;
      var state = scrollState();
      var target = Math.max(0, Math.min(state.maximum, state.position + state.sign * delta));
      rail.scrollTo({ left: state.sign * target, behavior: 'auto' });
    }

    function movePrevious() { move(-1); }
    function moveNext() { move(1); }

    previous.addEventListener('click', movePrevious);
    next.addEventListener('click', moveNext);
    rail.addEventListener('focusin', revealFocus);
    rail.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(requestUpdate) : null;
    if (observer) observer.observe(rail);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(requestUpdate);
    }

    cleanup.set(shell, function () {
      disposed = true;
      if (observer) observer.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
      previous.removeEventListener('click', movePrevious);
      next.removeEventListener('click', moveNext);
      rail.removeEventListener('focusin', revealFocus);
      rail.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      delete shell.dataset.mdvRailInitialised;
      cleanup.delete(shell);
    });

    requestUpdate();
  }

  function initialise(root) {
    (root && root.querySelectorAll ? root : document)
      .querySelectorAll('[data-mdv-collection-rail]').forEach(initialiseRail);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-mdv-collection-rail]').forEach(function (shell) {
      var dispose = cleanup.get(shell);
      if (dispose) dispose();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
